module.exports = __webpack_public_path__ + "static/media/home-bg-alt.71f7bbf8.jpg";